export default __webpack_public_path__ + "static/appscreenshots_4-afae80234338a38ff05cd06cff2772d2.png";